<template>
    <v-main class="pa-2" fluid>
        <h1>Packages</h1>
        <v-row>
            <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
                <!-- <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on">Add new Product</v-btn>
                </template> -->
                <v-card color="lighten-1">
                    <v-toolbar>
                        <v-toolbar-title>
                            <span class="headline">{{formTitle}}</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-form ref="form" v-model="valid" class="row">
                                    <v-col cols="12" md="12">
                                        <v-text-field label="Name" v-model="editedItem.name" :rules="nameRules" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="12">
                                        <fieldset class="inline-form">
                                            <v-text-field label="Internal Code" v-model="editedItem.code" :rules="codeRules" required
                                            ></v-text-field>
                                            
                                            <v-text-field label="Price" v-model="editedItem.price" :rules="codeRules" required prefix="$"
                                            ></v-text-field>
                                        </fieldset>

                                    </v-col>

                                    <v-col cols="12" md="12">
                                        <p><strong>Bookeo ID</strong> {{editedItem.productId}}</p>
                                        
                                    </v-col>
                                </v-form>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-data-table
            :headers="headers"
            :items="products"
            :items-per-page="20"
            class="elevation-1">
                 <template v-slot:item.actions="{ item }">

                <v-btn small class="ma-2" @click="edit(item)">
                  <v-icon center>mdi-pencil</v-icon> 
                </v-btn>
                
                </template>
            </v-data-table>
    </v-main>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        data() {
            return {
                headers: [
                    { text: '', value: 'data-table-expand' },
                    { text: 'Bookeo  Id', align: 'start', sortable: true, value: 'productId', },
                    
                    { text: 'Name', align: 'start', sortable: true, value: 'name', },
                    { text: 'Internal Code', align: 'start', sortable: true, value: 'code', },
                    { text: 'Price', align: 'start', sortable: true, value: 'price', },
                    { text: '', align: 'start', sortable: false, value: 'actions', },
                ],

                dialog: false,
                editedIndex: -1,
                valid: true,
                lazy: true,
                isEditing: null,
                editedItem: {
                    'name': '',
                    'code': ''
                },
                nameRules: [
                    v => !!v || 'Name is required',
                ],
                codeRules: [
                    v => !!v || 'code is required',
                ],
            }
        },

        // mounted () {
        //     this.$store.dispatch('fetchProducts')
        // },


        computed: {
            ...mapState(['products']),

            formTitle () {
                return this.editedIndex === -1 ? 'New Package' : 'Edit Package'
            },
        },

        watch: {
            dialog (val) {
              //  val || this.close()
            },
        },
        
        methods: {

            edit(item) { 

                this.editedIndex = this.products.indexOf(item);
                this.editedItem = Object.assign({}, item)

                this.dialog = true
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                  
                })
              },


              save () {

                if (this.editedIndex > -1) {


                    axios.put('/api/products/' + this.editedItem.id, this.editedItem)
                        .then( response => {

                            Object.assign(this.products[this.editedIndex], this.editedItem)
                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })

                  
                } else {


                    axios.post('/api/products', this.editedItem)
                    .then( response => {

                        this.products.push(this.editedItem)

                        this.close();
                        
                    })
                    .catch( err => {
                        console.log( err )
                    })
                  
                }

              }
          }
    }
</script>